import React, { useState, useEffect } from 'react';
import './Quotes.css';

function Quotes() {
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchQuotes = async () => {
      try {
        const response = await fetch('/api/quotes');
        if (!response.ok) throw new Error('Failed to fetch quotes');
        const data = await response.json();
        setQuotes(data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchQuotes();
  }, []);

  if (loading) return <div>Loading quotes...</div>;
  if (error) return <div>Error loading quotes: {error}</div>;

  return (
    <div className="masonry-grid">
      {quotes.slice().reverse().map((quote, index) => (
        <div key={index} className="masonry-item">          
          <div className="box">
            <div className="content">
              <h4 className="p-0 m-0 colorGreen">{quote.name}</h4>
              <p className="px-0 pt-1 pb-3 m-0 small">Customer since {quote.year}</p>
              <p>{quote.quote}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Quotes;